
export const dataList = [
  {
    id: 1,
    title: "Denim Jacket",
    img: "https://images.pexels.com/photos/2072453/pexels-photo-2072453.jpeg?auto=compress&cs=tinysrgb&w=600",
    actualPrice: "459",
    discountPrice: "449",
    rating: 1,
    label: "H&M",
    userVoted: "310",
  },
  {
    id: 2,
    title: "Formal Suit",
    img: "https://images.pexels.com/photos/532220/pexels-photo-532220.jpeg?auto=compress&cs=tinysrgb&w=600",
    actualPrice: "2499",
    discountPrice: "2249",
    rating: 2,
    label: "H&M",
    userVoted: "240",
  },
  {
    id: 3,
    title: "Aesthetic Round Hat",
    img: "https://images.pexels.com/photos/1036627/pexels-photo-1036627.jpeg?auto=compress&cs=tinysrgb&w=600",
    actualPrice: "299",
    discountPrice: "199",
    rating: 3,
    label: "H&M",
    userVoted: "590",
  },
  {
    id: 4,
    title: "Checked Shirt",
    img: "https://images.pexels.com/photos/769733/pexels-photo-769733.jpeg?auto=compress&cs=tinysrgb&w=600",
    actualPrice: "439",
    discountPrice: "289",
    rating: 4,
    label: "H&M",
    userVoted: "210",
  },
  {
    id: 5,
    title: "Solid Leather Jacket",
    img: "https://images.pexels.com/photos/977796/pexels-photo-977796.jpeg?auto=compress&cs=tinysrgb&w=600",
    actualPrice: "499",
    discountPrice: "449",
    rating: 1,
    label: "H&M",
    userVoted: "270",
  },
  {
    id: 6,
    title: "White T-Shirt",
    img: "https://images.pexels.com/photos/991509/pexels-photo-991509.jpeg?auto=compress&cs=tinysrgb&w=600",
    actualPrice: "199",
    discountPrice: "149",
    rating: 2,
    label: "H&M",
    userVoted: "810",
  },
  {
    id: 7,
    title: "Summer T-Shirt",
    img: "https://images.pexels.com/photos/1018911/pexels-photo-1018911.jpeg?auto=compress&cs=tinysrgb&w=600",
    actualPrice: "99",
    discountPrice: "44",
    rating: 3,
    label: "H&M",
    userVoted: "610",
  },
  {
    id: 8,
    title: "Woolen Scarf",
    img: "https://images.pexels.com/photos/375880/pexels-photo-375880.jpeg?auto=compress&cs=tinysrgb&w=600",
    actualPrice: "49",
    discountPrice: "40",
    rating: 4,
    label: "H&M",
    userVoted: "200",
  },
  {
    id: 9,
    title: "Leather Jacket",
    img: "https://images.pexels.com/photos/1036643/pexels-photo-1036643.jpeg?auto=compress&cs=tinysrgb&w=600",
    actualPrice: "499",
    discountPrice: "449",
    rating: 1,
    label: "H&M",
    userVoted: "210",
  },
  {
    id: 10,
    title: "Cotton T-Shirt",
    img: "https://images.pexels.com/photos/428333/pexels-photo-428333.jpeg?auto=compress&cs=tinysrgb&w=600",
    actualPrice: "399",
    discountPrice: "349",
    rating: 2,
    label: "H&M",
    userVoted: "21",
  },
  {
    id: 11,
    title: "High Neck",
    img: "https://images.pexels.com/photos/1578531/pexels-photo-1578531.jpeg?auto=compress&cs=tinysrgb&w=600",
    actualPrice: "1999",
    discountPrice: "1549",
    rating: 3,
    label: "H&M",
    userVoted: "290",
  },
  {
    id: 12,
    title: "Winter Jacket",
    img: "https://images.pexels.com/photos/374044/pexels-photo-374044.jpeg?auto=compress&cs=tinysrgb&w=600",
    actualPrice: "2499",
    discountPrice: "2049",
    rating: 4,
    label: "H&M",
    userVoted: "270",
  },
  {
    id: 13,
    title: "Casual Jacket",
    img: "https://images.pexels.com/photos/375806/pexels-photo-375806.jpeg?auto=compress&cs=tinysrgb&w=600",
    actualPrice: "1599",
    discountPrice: "1500",
    rating: 1,
    label: "H&M",
    userVoted: "430",
  },
  {
    id: 14,
    title: "Slim Suit",
    img: "https://images.pexels.com/photos/936564/pexels-photo-936564.jpeg?auto=compress&cs=tinysrgb&w=600",
    actualPrice: "3499",
    discountPrice: "2949",
    rating: 2,
    label: "H&M",
    userVoted: "650",
  },
  {
    id: 15,
    title: "Aesthetic Hoodie",
    img: "https://images.pexels.com/photos/1183266/pexels-photo-1183266.jpeg?auto=compress&cs=tinysrgb&w=600",
    actualPrice: "239",
    discountPrice: "209",
    rating: 3,
    label: "Mango",
    userVoted: "265",
  },
  {
    id: 16,
    title: "Summer T-Shirt",
    img: "https://images.pexels.com/photos/3116018/pexels-photo-3116018.jpeg?auto=compress&cs=tinysrgb&w=600",
    actualPrice: "1799",
    discountPrice: "1649",
    rating: 4,
    label: "Mango",
    userVoted: "97",
  },
  {
    id: 17,
    title: "Printed Shirt",
    img: "https://images.pexels.com/photos/2313192/pexels-photo-2313192.jpeg?auto=compress&cs=tinysrgb&w=600",
    actualPrice: "599",
    discountPrice: "449",
    rating: 3,
    label: "Mango",
    userVoted: "28",
  },
  {
    id: 18,
    title: "Printed T-Shirt",
    img: "https://images.pexels.com/photos/1561011/pexels-photo-1561011.jpeg?auto=compress&cs=tinysrgb&w=600",
    actualPrice: "799",
    discountPrice: "499",
    rating: 4,
    label: "Mango",
    userVoted: "30",
  },
  {
    id: 19,
    title: "Baggy Jeans",
    img: "https://images.pexels.com/photos/2072453/pexels-photo-2072453.jpeg?auto=compress&cs=tinysrgb&w=600",
    actualPrice: "599",
    discountPrice: "449",
    rating: 3,
    label: "Mango",
    userVoted: "120",
  },
  {
    id: 20,
    title: "Sunglasses",
    img: "https://images.pexels.com/photos/160426/lead-man-sun-sunglasses-160426.jpeg?auto=compress&cs=tinysrgb&w=600",
    actualPrice: "99",
    discountPrice: "44",
    rating: 4,
    label: "Mango",
    userVoted: "936",
  },
  {
    id: 21,
    title: "Jordans",
    img: "https://images.pexels.com/photos/2736565/pexels-photo-2736565.jpeg?auto=compress&cs=tinysrgb&w=600",
    actualPrice: "2099",
    discountPrice: "1949",
    rating: 2,
    label: "Mango",
    userVoted: "875",
  },
  {
    id: 22,
    title: "Unisex Scarf",
    img: "https://images.pexels.com/photos/605206/pexels-photo-605206.jpeg?auto=compress&cs=tinysrgb&w=600",
    actualPrice: "95",
    discountPrice: "49",
    rating: 3,
    userVoted: "870",
    label: "Mango",
  },
  {
    id: 23,
    title: "Baggy Shirt",
    img: "https://images.pexels.com/photos/3612409/pexels-photo-3612409.jpeg?auto=compress&cs=tinysrgb&w=600",
    actualPrice: "1875",
    discountPrice: "1670",
    rating: 4,
    userVoted: "243",
    label: "Mango",
  },
  {
    id: 24,
    title: "Burnout Jeans",
    img: "https://images.pexels.com/photos/2315303/pexels-photo-2315303.jpeg?auto=compress&cs=tinysrgb&w=600",
    actualPrice: "329",
    discountPrice: "279",
    rating: 2,
    userVoted: "210",
    label: "Mango",
  },
  {
    id: 25,
    title: "Brown Jacket",
    img: "https://images.pexels.com/photos/923711/pexels-photo-923711.jpeg?auto=compress&cs=tinysrgb&w=600",
    actualPrice: "1769",
    discountPrice: "1679",
    rating: 5,
    label: "Mango",
    userVoted: "320",
  },
  {
    id: 26,
    title: "Base Coat",
    img: "https://images.pexels.com/photos/3206168/pexels-photo-3206168.jpeg?auto=compress&cs=tinysrgb&w=600",
    actualPrice: "499",
    discountPrice: "449",
    rating: 5,
    userVoted: "910",
    label: "Mango",
  },
  {
    id: 27,
    title: "Funky Suit",
    img: "https://images.pexels.com/photos/1863476/pexels-photo-1863476.jpeg?auto=compress&cs=tinysrgb&w=600",
    actualPrice: "1799",
    discountPrice: "1649",
    rating: 5,
    userVoted: "40",
    label: "Mango",
  },
  {
    id: 28,
    title: "Ripped Jeans",
    img: "https://images.pexels.com/photos/936023/pexels-photo-936023.jpeg?auto=compress&cs=tinysrgb&w=600",
    actualPrice: "2109",
    discountPrice: "1949",
    rating: 5,
    userVoted: "80",
    label: "Mango",
  },
  {
    id: 29,
    title: "Sports T-Shirt",
    img: "https://images.pexels.com/photos/1103832/pexels-photo-1103832.jpeg?auto=compress&cs=tinysrgb&w=600",
    actualPrice: "299",
    discountPrice: "144",
    rating: 5,
    userVoted: "20",
    label: "H&M",
  },
  {
    id: 30,
    title: "Sweatshirt",
    img: "https://images.pexels.com/photos/3014811/pexels-photo-3014811.jpeg?auto=compress&cs=tinysrgb&w=600",
    actualPrice: "499",
    discountPrice: "449",
    rating: 5,
    userVoted: "290",
    label: "Mango",
  },
];

export const ItemsData = [
  { id: 1, checked: false, label: "Mango", desc: "Mango" },
  { id: 2, checked: false, label: "H&M", desc: "H&M" },
];

export const PriceData = [
  { id: 1, checked: false, label: 500, desc: "Under 500" },
  { id: 2, checked: false, label: 1000, desc: "1000 To 3000" },
];

export const RatingsData = [
  { id: 1, checked: false, label: 5, desc: "⭐⭐⭐⭐⭐" },
  { id: 2, checked: false, label: 4, desc: "⭐⭐⭐⭐" },
  { id: 3, checked: false, label: 3, desc: "⭐⭐⭐" },
  { id: 4, checked: false, label: 2, desc: "⭐⭐" },
  { id: 5, checked: false, label: 1, desc: "⭐" },
];

export const suggestiondata = [
  {
    id: 2,
    title: "Formal Suit",
    img: "https://images.pexels.com/photos/532220/pexels-photo-532220.jpeg?auto=compress&cs=tinysrgb&w=600",
    actualPrice: "2499",
    discountPrice: "2249",
    rating: 2,
    label: "H&M",
    userVoted: "240",
  },
  {
    id: 3,
    title: "Round Hat",
    img: "https://images.pexels.com/photos/1036627/pexels-photo-1036627.jpeg?auto=compress&cs=tinysrgb&w=600",
    actualPrice: "299",
    discountPrice: "199",
    rating: 3,
    label: "H&M",
    userVoted: "590",
  },
  {
    id: 4,
    title: "Checked Shirt",
    img: "https://images.pexels.com/photos/769733/pexels-photo-769733.jpeg?auto=compress&cs=tinysrgb&w=600",
    actualPrice: "439",
    discountPrice: "289",
    rating: 4,
    label: "H&M",
    userVoted: "210",
  },
  {
    id: 5,
    title: "Solid Jacket",
    img: "https://images.pexels.com/photos/977796/pexels-photo-977796.jpeg?auto=compress&cs=tinysrgb&w=600",
    actualPrice: "499",
    discountPrice: "449",
    rating: 1,
    label: "H&M",
    userVoted: "270",
  },
  {
    id: 6,
    title: "White T-Shirt",
    img: "https://images.pexels.com/photos/991509/pexels-photo-991509.jpeg?auto=compress&cs=tinysrgb&w=600",
    actualPrice: "199",
    discountPrice: "149",
    rating: 2,
    label: "H&M",
    userVoted: "810",
  },
];
